import axios from "axios";
import { Location, LoaderFunction } from "react-router-dom";


export function sendLogPublicWhenSearchStart({
    location,
    params,
    search_keyword = '',
    search_total = '',
    search_category = '',
    search_floor = '',
}: {
    location: Location,
    params: Parameters<LoaderFunction>[0]["params"],
    search_keyword?: string,
    search_total?: string,
    search_category?: string,
    search_floor?: string,
}) {
    const query = new URLSearchParams(location.search);
    const { group, floor, from, to, code } = params;
    const q = query.get('q');
    const search = location.search;
    const pathname = location.pathname;

    const event_name = 'search_start';

    axios.post(import.meta.env.VITE_APP_LOG_URL || "", {
        floor_group_id: group,
        from_point_id: from,
        to_point_id: to,
        floor_id: floor,
        search: search,
        pathname: pathname,
        event_name,
        search_keyword,
        search_category,
        search_floor,
        search_total,
        code,
        q: q,
    });
}
